<template>
  <div>
    <el-dialog :visible.sync="addServiceDialog" width="50%" title="投资分成">
      <el-form :model="form" label-width="auto" ref="investForm">
        <el-form-item label="投资人" v-if="form.id">
          {{ form.name }}
        </el-form-item>
        <el-form-item label="投资人" v-else>
          <el-input v-model="phone" placeholder="输入手机号"></el-input>
          <el-button type="primary" @click="getAdmin">搜索</el-button>
          <el-select v-model="form.admin_id" placeholder="选择投资人">
            <el-option
              v-for="(item, index) in admin_list"
              :key="index"
              :label="item.name"
              :value="item.id"
              @click.native="changeAdmin(item)"
            ></el-option>
          </el-select>
        </el-form-item>
         <el-button type="text" @click="toAddRole">添加投资人，身份为：联营社投资人</el-button>
      
           <el-form-item label="投资方式" required>
          <el-radio v-for="(item,i) in investTypes" :key="i" v-model="form.type" :label="item.value">{{item.name}}</el-radio>
        </el-form-item>
        <el-form-item label="投资金额">
          <el-input
            v-model="form.invest_amount"
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>
        <div class="title">收益分成</div>
        <el-button type="primary" icon="el-icon-plus" @click="addRatio">添加分成</el-button>
        <el-form-item
          :label="ratioTypeMap[r.type]"
          v-for="(r, i) in ratios"
          :key="i"
        >
          <div class="flex">
            <el-input
              v-model.number="r.ratio"
              placeholder="比例,如0.5"
              type="number"
              :max="1"
              :min="0"
            ></el-input>
              <div class="cate" @click="openCategory(r)">
                {{ r.divide_category || "选择分成类目" }}
             </div>
            <el-button v-if="r.id" type="primary" @click="updateRatioInfo(r)"
              >更新</el-button
            >
             <el-button v-else-if="form.admin_id" type="success" @click="addRatioInfo(r)"
              >添加</el-button
            >
          </div>
        </el-form-item>
        <div>
          若所有类目都分成不要选择分成类目，默认全分
        </div>
     
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addServiceDialog = false">取 消</el-button>
        <el-button
          :loading="loading"
          v-if="form.id"
          type="primary"
          @click="updateForm()"
          >修 改</el-button
        >
        <el-button
          v-else
          :loading="loading"
          type="primary"
          @click="submitForm()"
          >添 加</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
        title="选择类目"
        :visible.sync="cateShow"
        width="60%"
        append-to-body
      >
        <el-transfer
          filterable
          filter-placeholder="请选择绑定的科目"
          v-model="changeCates"
          :data="categories_child_list"
          :props="{
            key: 'name',
            label: 'name',
          }"
          :titles="['所有类目', '拥有类目']"
        >
        </el-transfer>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cateShow = false">取 消</el-button>
          <el-button type="primary" @click="confirmCategory">确 定</el-button>
        </span>
      </el-dialog>
  </div>
</template>
  
  <script>
import { ObjectChangedValue } from "@/js/utils";
import {investTypes} from '../dict.js'
export default {
  data() {
    return {
      investTypes,
      phone: "",
      admin_list: [],
      form: {},
      ratioTypeMap: {
        1: "收益分成",
      },
      ratios: [{ ratio: "", type: 1 ,divide_category: ''}],
      temp: {},
      addServiceDialog: false,
      id: "",
      loading: false,
      categories_child_list: [],
      cateShow: false,
      changeCates: [],
      curRatio: {}
    };
  },
  mounted() {
    this.id = this.$route.query.mecID;
    this.getCateList()
  },

  methods: {
    toAddRole(){
      this.$router.push({
        name: 'RoleSettings'
      })
    },
    addRatio(){
        this.ratios.push({ ratio: "", type: 1 ,divide_category: ''})
    },
    openCategory(r){
        this.curRatio = r
        this.cateShow = true
    },
     confirmCategory() {
      this.curRatio.divide_category = this.changeCates.join(",");
      this.cateShow = false;
    },
    getCateList() {
      let url = "/user/mechanismCategory/queryListPageChild";
      let data = {
        status: 2,
        type: 2,
        source: "课程",
      };
      
      this.$axios
        .get(url, {
          params: data,
        })
        .then((res) => {
          this.categories_child_list = res.data.data;
        });
    },
    blurRatio(v) {
      let value = v.target.value;
      if (value < 0 || value > 1) {
        v.target.value = 0;
        this.$message("分成比例错误");
      }
    },
    changeAdmin(item) {
      this.form.admin_id = item.id;
      this.form.name = item.name;
      this.form.phone = item.mobile;
    },
    getAdmin() {
      let url = "/authorization/managerUser/queryListPage";
      this.$axios
        .get(url, {
          params: {
            login_name: this.phone,
            type: "union",
          },
        })
        .then((res) => {
          this.admin_list = res.data.data;
        });
    },
    open(info) {
          this.loading = false;
      if (info && info.id) {
        this.form = { ...info };
        this.temp = { ...info };
        this.getRatio();
      } else {
        this.form = {};
        this.temp = {};
        this.ratios = [{ ratio: "", type: 1 ,divide_category: ''}];
      }

      this.addServiceDialog = true;
    },
    getRatio() {
      let data = {
        mechanism_id: this.id,
        invest_id: this.temp.admin_id,
      };
      this.$get("/user/unionMechanismRatio/queryListPage", data).then((res) => {
        this.ratios = res.data.data;
      });
    },
    updateRatioInfo(row) {
      if (row.ratio < 0 || row.ratio > 1) {
        this.$message("分成比例错误");
        return;
      }
      let data = {
        id: row.id,
        ratio: row.ratio,
        divide_category: row.divide_category || null,
        mechanism_id: this.id
      };
      this.$post("/user/unionMechanismRatio/update", data).then((res) => {
          this.form = {};
          this.temp = {};
          this.addServiceDialog = false;
          this.$emit("success");
        })
    },
    addRatioInfo(row) {
      if (row.ratio < 0 || row.ratio > 1) {
        this.$message("分成比例错误");
        return;
      }
      let data = {
        invest_id: this.form.admin_id,
        ratio: row.ratio,
        mechanism_id: this.id,
        divide_category: row.divide_category || null,
        type: 1
      };
      this.$post("/user/unionMechanismRatio/insert", data).then((res) => {
          this.form = {};
          this.temp = {};
          this.addServiceDialog = false;
          this.$emit("success");
        })
    },
    updateForm() {
      if (this.check()) {
        let data = ObjectChangedValue(this.temp, this.form);
        data.id = this.form.id;
        let url = "/user/mechanismInvest/update";
        this.loading = true;
        this.$axios.post(url, data).then((res) => {
          this.form = {};
          this.temp = {};
          this.loading = false;
          this.addServiceDialog = false;
          this.$emit("success");
        }).catch(()=>{
          this.loading = false;
        })
      }
    },
    submitForm() {
      if (this.check()) {
        let url = "/user/mechanismInvest/insert";
        let data = {
          ...this.form,
          mechanism_id: this.id,
          ratios: this.ratios,
        };
        this.loading = true;
        this.$axios.post(url, data).then((res) => {
          this.loading = false;
          this.addServiceDialog = false;
          this.form = {};
          this.$emit("success");
        }).catch(()=>{
          this.loading = false;
        })
      }
    },
    check() {
      if (!this.form.admin_id) {
        this.$message("请选择投资人");
        return false;
      }
      return true;
    },
  },
};
</script>
  
  <style lang="less" scoped>
  .cate{
    margin-left: 10px;
  }
</style>